export default "__VITE_ASSET__SIcIzFuU__"